// The backend's own wording for a failure, or null when it sent none.
//
// `apiRequest` puts the response `message` on ApiError and falls back to the
// literal "HTTP <status>" when the body carried nothing — that string is not a
// reason, so it is reported as "no message" and the caller words the case.
export function backendMessage(err: unknown): string | null {
  if (!(err instanceof Error)) return null;

  const message = err.message.trim();
  if (message === '' || /^HTTP \d+$/.test(message)) return null;

  return message;
}
